module.exports = __webpack_public_path__ + "img/tw.e2d2694a.svg";